import './App.css';
import System from './components/system/System';

function App() {
  return (
    <>
    <System/>
    </>
  );
}

export default App;
